module.exports = __webpack_public_path__ + "static/media/Gmail_logo.735d4db9.jpg";